import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import {
    CurrentStandardVersionAction,
    NotifyUserForStandardVersionChange,
    StandaloneState
} from '../../store/standalone';
import {selectStandaloneState} from '../../store';
import {firstValueFrom, of} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import JSZip from 'jszip';
import {catchError} from 'rxjs/operators';
import {StandardProductManagerDatabase} from "../../sqllite/databases/standard-product-manager.database";

@Injectable({
    providedIn: 'root'
})export class StandardsProductsSynchronizer {

    private countryIsoCode:string;

    constructor(private readonly store: Store<StandaloneState>,
                private readonly messageService: MessageService,
                private readonly translateService: TranslateService,
                private readonly standardProductManagerDatabase: StandardProductManagerDatabase,
                private httpClient: HttpClient) {
    }

    public async init(countryIsoCode: string) {
        this.countryIsoCode = countryIsoCode;
        console.log("INIT StandardsProductsSynchronizer")
        if(! await this.standardProductManagerDatabase.exists()) {
            console.log("INIT !existingDb StandardsProductsSynchronizer lunch synchronizeNewVersion ...")
            await this.synchronizeProducts();
        }
        this.notifyStandardVersionChange();
    }

    async synchronizeProducts() {
        console.time('synchronizeProducts');
        const storedEtag = (await firstValueFrom(this.store.select(selectStandaloneState))).currentStandardVersion || '';
        const headers = storedEtag ? { 'If-None-Match': storedEtag } : {};
        const response = await  firstValueFrom(
            this.httpClient
            .get(`/apiProduct2/v2/sync/download/${this.countryIsoCode}/latest`,
                { headers: new HttpHeaders(headers), observe: 'response', responseType: 'blob' })
                .pipe(catchError(err => of(err)))
        );
        if (response.status === 200 && response.headers.has('ETag')) {
            const zip = await JSZip.loadAsync(response.body!);
            const fileName = Object.keys(zip.files)[0];
            const dbFile = await zip.files[fileName].async('uint8array');
            await this.standardProductManagerDatabase.saveAndLoadDb(dbFile);
            if(storedEtag !== '') {
                this.store.dispatch(new NotifyUserForStandardVersionChange(true));
            }
            this.store.dispatch(new CurrentStandardVersionAction(response.headers.get('ETag')));
        }else if (response.status === 304) {
            console.log('Fichier des articles standards est déjà à jour, pas besoin de retélécharger.');
        }
        console.timeEnd('synchronizeProducts');
    }

    private notifyStandardVersionChange() {
        this.store.select(selectStandaloneState).subscribe((standaloneState:StandaloneState) => {
            if(standaloneState.notifyStandardVersionChange) {
                this.messageService.add({
                    severity: 'info',
                    detail: this.translateService.instant('NEW_STANDARD_DATABASE_IS_CHARGED'),
                    life: 20000,
                    closable: true,
                    key: 'noDuplicateToast'
                });
                this.store.dispatch(new NotifyUserForStandardVersionChange(false));
            }
        });
    }

}

